import {
  Checkbox,
  FormControlLabel,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core"
import CheckBoxIcon from "@material-ui/icons/CheckBox"
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank"
import PropTypes from "prop-types"
import React from "react"
import HoverText from "~/components/Common/HoverText"
import PaperListRow from "~/components/Common/PaperListRow"
import Box from "../../Common/Box"
import useStyles from "./styles"

const TestUserCard = ({ testUser, i, assignTestUsersFunc, checked }) => {
  const classes = useStyles()
  const theme = useTheme()
  const smScreen = useMediaQuery(theme.breakpoints.down("sm"))

  return (
    <Box marginBottom="16px">
      <PaperListRow
        key={i}
        componentWidth="100%"
        componentHeight={smScreen ? "90px" : "64px"}
      >
        {smScreen ? (
          <Box display="flex" alignItems="center" className={classes.nameText}>
            <span className={classes.labelSpan}>Name:&nbsp;&nbsp;</span>
            <HoverText
              data={testUser.first_name + " " + testUser.last_name}
              size={100}
              variant={"subtitle1"}
            />
          </Box>
        ) : (
          <Box display="flex" alignItems="center" className={classes.nameText}>
            <HoverText
              data={testUser.first_name + " " + testUser.last_name}
              size={100}
              variant={"subtitle1"}
            />
          </Box>
        )}
        {smScreen ? (
          <Box display="flex" alignItems="center" className={classes.emailText}>
            <span className={classes.labelSpan}>Email:&nbsp;&nbsp;</span>
            <HoverText data={testUser.email} size={95} variant={"subtitle1"} />
          </Box>
        ) : (
          <Box display="flex" alignItems="center" className={classes.emailText}>
            <HoverText data={testUser.email} size={95} variant={"subtitle1"} />
          </Box>
        )}
        {smScreen ? (
          <Box display="flex" alignItems="center" className={classes.idText}>
            <span className={classes.labelSpan}>User ID:&nbsp;&nbsp;</span>
            <Typography variant="subtitle1">{testUser.id}</Typography>
          </Box>
        ) : (
          <Box display="flex" alignItems="center" className={classes.idText}>
            <Typography variant="subtitle1">{testUser.id}</Typography>
          </Box>
        )}
        {smScreen ? (
          <FormControlLabel
            control={
              <Checkbox
                checked={testUser.assigned || checked}
                disabled={testUser.assigned}
                onChange={(e) =>
                  assignTestUsersFunc(testUser.id, e.target.checked)
                }
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                name="setTestUser"
              />
            }
            label="Assign"
          />
        ) : (
          <Box className={classes.checkBox}>
            <Checkbox
              checked={testUser.assigned || checked}
              disabled={testUser.assigned}
              onChange={(e) =>
                assignTestUsersFunc(testUser.id, e.target.checked)
              }
            />
          </Box>
        )}
      </PaperListRow>
    </Box>
  )
}

TestUserCard.propTypes = {
  testUser: PropTypes.object,
  i: PropTypes.string,
  assignTestUsersFunc: PropTypes.func,
  checked: PropTypes.bool,
}

export default TestUserCard
